module.exports = __webpack_public_path__ + "img/chemical_active.a227e9b4.svg";